export default {
      id: "logo-usage",
      viewBox: "0 0 750 236",
      url: __webpack_public_path__ + "icons.svg#logo",
      toString: function () {
        return this.url;
      }
    }